import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=c4305df0&scoped=true"
import script from "./Observation.vue?vue&type=script&lang=js"
export * from "./Observation.vue?vue&type=script&lang=js"
import style0 from "./Observation.vue?vue&type=style&index=0&id=c4305df0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4305df0",
  null
  
)

export default component.exports